import CoreBase from '../../../../../services/engines/CoreBase';

class ContextMenuHandler extends CoreBase {
    _name = 'ContextMenuHandler';

    /**
     * Handles jerny:contextmenu — dispatches contextmenu event with iframe-adjusted coordinates.
     * Coords uit iframe zijn relatief aan iframe viewport — rect offset erbij optellen.
     * @param {MessageEvent} e
     * @param {HTMLIFrameElement} iframe
     */
    handle = (e, iframe) => {
        try {
            // alleen verwerken als het van onze iframe komt
            if (e.source !== iframe?.contentWindow) return;

            const rect = iframe?.getBoundingClientRect() ?? { left: 0, top: 0 };

            window.dispatchEvent(new CustomEvent('jerny:contextmenu', {
                detail: {
                    x: rect.left + e.data.x,
                    y: rect.top + e.data.y,
                },
            }));
        } catch (error) {
            this.logError('handle', error.message);
        }
    };
}

const contextMenuHandler = new ContextMenuHandler();
export default contextMenuHandler;
